import ReferralSectionContainer from './ReferralSectionContainer'
import ReferralTile from './ReferralTile'

export { ReferralSectionContainer, ReferralTile }

export default ReferralSectionContainer
